import { AxiosResponse } from "axios";
import { http } from "../utils/http";
import { IFilterUserPagination, IUser } from "../interface/user";

export const filterGenderVerificationApi = async (payload: {
  status?: number;
  role?: "user" | "driver";
  page: number;
  limit: number;
}): Promise<AxiosResponse<IFilterUserPagination>> => {
  return await http.get("/v1/admin/users/gender-verification", payload);
};

export const getKycImageApi = async (
  id: string,
  kind: "face" | "idCard"
): Promise<AxiosResponse<Blob>> => {
  return await http.get(
    `/v1/admin/users/${id}/kyc/${kind}`,
    {},
    true,
    undefined,
    "blob"
  );
};

export const updateGenderVerificationApi = async (
  id: string,
  payload: { status: 2 | 3; method: "kyc" | "in_person" }
): Promise<AxiosResponse<IUser>> => {
  return await http.put(`/v1/admin/users/${id}/gender-verification`, payload);
};
